import request from '@/util/http'



// 系统文件上传
export const sysFileUpload=(param)=>{
    let fileName = param.get('file').name;
    if(fileName.length<=30){
        return new Promise((resolve,reject) => {
            request({
                headers:{
                    "Content-Type": "multipart/form-data"
                },
                url: '/admin/file/upload',
                method: 'post',
                data: param
            }).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err)
            })
        })
    }else{
        return  Promise.resolve({
                data:{
                    code: 1,
                    msg: '文件名过长，请重新修改后上传'}
        })
    }
}

// 文件下载
export const handleDownload=(id)=> {
    return `/admin/file/download/${id}`;
}


// 系统文件删除
export const sysFileDelete=(id)=>request({
    url: `/admin/file/delete/${id}`,
    method: 'delete'
})
// 服务文件上传
export const serveFileUpload=(param)=>{
    let fileName = param.get('file').name;
    if(fileName.length<=30){
        return new Promise((resolve,reject) => {
            request({
                headers:{
                    "Content-Type": "multipart/form-data"
                },
                url: '/admin/serveFile/upload',
                method: 'post',
                data: param
            }).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err)
            })
        })
    }else{
        return  Promise.resolve({
                data:{
                    code: 1,
                    msg: '文件名过长，请重新修改后上传'}
        })
    }

}

// 文件下载
export const handleserveFileDownload=(id)=> {
    return `/admin/serveFile/download/${id}`;
}

// 服务文件删除
export const serveFileDelete=(id)=>request({
    url: `/admin/serveFile/delete/${id}`,
    method: 'delete'
})

// 查询所有服务列表
export const getHallServeList=(params)=>request({
    url: '/admin/tHallServe/list',
    method: 'get',
    params
})
// 角色列表查询
export const getRoleList=()=>request({
    url: '/admin/role/list',
    method: 'get',
})


// 部门树形数据查询
export const getDeptTree=(params)=>request({
    url: '/admin/dept/tree',
    method: 'get',
    params:params||{}
})

// 部门树形数据查询
export const moveDept=(params)=>request({
        url: '/admin/dept/move',
        method: 'post',
        params
    })

// 分页查询用户
export const getUserPageTwo=(params)=>request({
    url: '/admin/user/page2',
    method: 'get',
    params
})



